import { Switch, SwitchProps } from "antd";
import React from "react";

type ITogglePosition = "position-bottom-left" | "position-bottom-right" | "position-top-left" | "position-top-right";

interface IProps extends SwitchProps {
  position?: ITogglePosition;
}

const Toggle: React.FC<IProps> = ({ className, position = "position-top-right", ...otherOptions }) => (
  <Switch {...otherOptions} className={[position, className].join(" ")} />
);

export default Toggle;
